import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Crown, LogIn } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

/** Global prompt for sign-in-required and free-ceiling-reached API errors. */
export default function FreeAccessModal() {
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const onEvt = (e) => setInfo(e.detail);
    window.addEventListener("sr:free-access", onEvt);
    return () => window.removeEventListener("sr:free-access", onEvt);
  }, []);

  if (!info) return null;
  const signIn = info.code === "sign_in_required";
  const go = (path) => {
    setInfo(null);
    navigate(path, { state: { from: loc.pathname } });
  };

  return (
    <Dialog open onOpenChange={(o) => !o && setInfo(null)}>
      <DialogContent data-testid={signIn ? "signin-required-modal" : "free-ceiling-modal"}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {signIn ? <LogIn size={20} /> : <Crown size={20} className="text-spark-purple" />}
            {signIn ? "Sign in to save your results" : "Your free learning period is complete"}
          </DialogTitle>
          <DialogDescription data-testid="free-access-modal-message">{info.message}</DialogDescription>
        </DialogHeader>
        {signIn && (
          <p className="text-sm text-muted-foreground">
            Your answers are kept — you'll come right back to this page.
          </p>
        )}
        <DialogFooter className="gap-2">
          {signIn ? (
            <>
              <button className="btn-ghost" onClick={() => go("/login")} data-testid="modal-signin-btn">Sign in</button>
              <button className="btn-primary" onClick={() => go("/register")} data-testid="modal-register-btn">Create free account</button>
            </>
          ) : (
            <>
              <button className="btn-ghost" onClick={() => go("/dashboard")} data-testid="modal-progress-btn">Review my progress</button>
              <button className="btn-primary" onClick={() => go("/pricing")} data-testid="modal-upgrade-btn">See membership options</button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
